export default "__VITE_ASSET__CTcKRAWX__"